module.exports = __webpack_public_path__ + "static/media/donbosco3.66d8346a.jpg";